import { default as Modal } from './AbstractModal';

export default class extends Modal {

    constructor(m) {
        super(m);

        this.$el = this.el
        this.$video = this.$('video')[0]
    }

    onOpen(e) {

        if(this.emptyTimeout) {
            clearTimeout(this.emptyTimeout);
        }

        this.appendDelay = setTimeout(() => {
            console.log(e.id)
            switch (e.host) {
                case 'youtube':
                    this.$video.innerHTML = `<iframe src="https://www.youtube.com/embed/${e.id}?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
                    break;
                case 'vimeo':
                    this.$video.innerHTML = `<iframe src="https://player.vimeo.com/video/${e.id}?autoplay=1&loop=1&autopause=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
                    break;
                case 'mp4':
                    this.$video.innerHTML = `<video src="${e.id}" autoplay controls></video>`
                    break;
                default:
                    break;
            }
        }, 300)

    }

    onClose() {
        clearTimeout(this.appendDelay)
        this.emptyTimeout = setTimeout(() => {
            this.$video.innerHTML='';
        }, 600);
    }
}
